function iframeSandboxDomainStrategy(metaSiteId, experiments) {
  var _a;
  const iframeSandboxDomainParams = {};
  if (metaSiteId) {
    const host = ((_a = experiments == null ? void 0 : experiments.iframeSandboxSecondaryHost) == null ? void 0 : _a.enabled) ? "usrfiles" : "filesusr";
    iframeSandboxDomainParams.iframeSandboxDomain = `https://${metaSiteId}.${host}.com`;
  }
  return iframeSandboxDomainParams;
}
export {
  iframeSandboxDomainStrategy as default
};
//# sourceMappingURL=iframeSandboxDomainStrategy.js.map
